export const IAM_PREFIX = '/iam';
export const IS_AUTHORIZED_PATH = `${IAM_PREFIX}/users/me`;
export const USER_ORGANIZATIONS_PATH = `${IAM_PREFIX}/users/me/organizations`;
export const ID_TOKEN_HINT_PATH = (organizationId: string) =>
  `${IAM_PREFIX}/users/me/organizations/${organizationId}/id-token-hint`;
